<template>
    <div class="product-rating">
        <div class="back-stars">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>

            <div class="front-stars" :style="{ width: ratingPercent + '%' }">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </div>
        </div>

        <span class="rating-count" v-if="hasReviewCount">({{ this.reviewCount }})</span>
    </div>
</template>

<script>
    export default {
        props: ['ratingPercent', 'reviewCount'],

        computed: {
            hasReviewCount() {
                return this.reviewCount !== undefined;
            },
        },
    };
</script>
